export interface IServices {}

export default class Services implements IServices {
  constructor(obj: IServices) {
    Object.assign(this, obj);
  }

  static data = [
    {
      _id: 0,
      type: "Base",
      promos: 1,
      devices: 200,
      notis: 2,
      price: "15",
      discountPrice: "9",
      duration: "mese",
    },
    {
      _id: 1,
      type: "Standard",
      promos: 2,
      devices: 500,
      notis: 4,
      price: "50",
      discountPrice: "29",
      duration: "mese",
    },
    {
      _id: 2,
      type: "Premium",
      promos: 3,
      devices: 2000,
      notis: 6,
      price: "100",
      discountPrice: "49",
      duration: "mese",
    },
  ];
}
